<template>
  <div v-if="book" class="flex justify-between items-center cursor-pointer">
    <div
      class="flex items-center justify-center rounded-full flex-shrink-0 font-medium"
      :class="[bookColor.accent ? 'text-dark-600' : 'text-app-color', computedBackground, customClasses]"
      :style="`background-color: ${style}`"
    >
      {{ firstLetter }}
    </div>
    <span class="text-app-color truncate text-center w-full">{{ book.title }}</span>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import defaultColors from '@/core/colors'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'BookLabel',

  props: {
    book: Object,
    background: { type: String },
    customClasses: { type: String, default: 'mr-8 text-14 w-30 h-30' }
  },

  setup (props) {
    const { getters, state } = useStore()
    const firstLetter = computed(() => {
      return props.book.title.charAt(0).toUpperCase()
    })

    const headquarters = computed(() => state.team.headquarters)

    const style = computed(() => {
      if (headquarters.value?.id === props.book.id) return 'moccasin'
      return bookColor.value.accent
    })

    const bookColor = computed(() => {
      const color = defaultColors.bookColors.find(c => c.name === props.book.color)

      return color || { main: null, accent: null }
    })

    const isDarkMode = computed(() => getters.isDarkMode)

    const computedBackground = computed(() => {
      return props.background || (isDarkMode.value ? 'bg-error' : 'bg-grey-400')
    })

    return {
      // ref
      // data
      style,
      bookColor,
      firstLetter,
      // computed
      computedBackground
      // function
    }
  }
})
</script>
